<template>
  <div
    class="html_winTeam_ad"
    ref="html_winTeam_ad"
    v-if="datas.objectInfo && datas.objectInfo.length > 0"
  >
    <div class="main">
      <CombatPlayersScore :datas="combatTeamScore"></CombatPlayersScore>
      <span class="dataList" v-if="tableData">
        <span
          class="dataList_item"
          v-for="item in datas.statisticsModels"
          :key="item.statisticalEn"
        >
          <RingValTextItem
            :val="[tableData[item.statisticalEn], item.name]"
          ></RingValTextItem>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
// 获胜球队 双人 || 单人
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
import CombatPlayersScore from '../components/CombatPlayersScore.vue'
import RingValTextItem from '../components/RingValTextItem.vue'
export default {
  name: 'html_winTeam_ad',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    RingValTextItem,
    CombatPlayersScore,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {}
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    tableData() {
      return this.datas.data.dataList && this.datas.data.dataList.length > 0
        ? this.datas.data.dataList[0]
        : null
    },
    combatTeamScore() {
      return this.datas && this.datas.objectInfo ? this.datas.objectInfo : []
    },
  },
  methods: {
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (text) {
          data = `${text}: ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_winTeam_ad {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 80%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);

    .dataList {
      padding-top: 1.66vw;
      width: 100%;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-evenly;
      align-items: center;
      .dataList_item {
        width: 33%;
        &:nth-child(2) {
          width: 34%;
        }
      }
    }
  }
}
</style>
